import type { TaskStatus } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'
import type { TaskResponse } from '../queries/tasks.queries'

// Create a task
export const createTask = async (data: Partial<TaskResponse>) => {
  const response = await gozokiApiWithAuth.post<TaskResponse>('/real-estate-tasks', data)
  return response.data
}

// Update a task
export const updateTask = async ({ id, data }: { id: string; data: Partial<TaskResponse> }) => {
  const response = await gozokiApiWithAuth.patch<TaskResponse>(`/real-estate-tasks/${id}`, data)
  return response.data
}

// Delete a task
export const deleteTask = async (id: string) => {
  const response = await gozokiApiWithAuth.delete(`/real-estate-tasks/${id}`)
  return response
}

// Update task position (handles both status and position changes)
export const updateTaskPosition = async ({
  id,
  status,
  position,
}: {
  id: string
  status: TaskStatus
  position: number
}) => {
  const response = await gozokiApiWithAuth.patch<{
    id: string
    status: string
    displayOrder: number
  }>(`/real-estate-tasks/${id}/position`, { status, position })
  return response.data
}
